module.exports = __webpack_public_path__ + "media/icons/plus-f63a54da6485495a30e2df1de2e4aa76.svg";